import { Helmet } from 'react-helmet-async';
import ActivationsAnalyzeView from 'src/sections/overview/dashboards/activations/analyze/view';

export default function SearchPerformanceExplore() {
  return (
    <>
      <Helmet>
        <title>Explore</title>
      </Helmet>

      <ActivationsAnalyzeView />
    </>
  );
}
